import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  Alert,
  Avatar,
  Box,
  Button,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  Slide,
  Snackbar,
  Typography,
} from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import { capitalizeFirstLetter } from "../../../utils/Utils";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import moment from "moment";
import axios from "axios";
import config from "../../../config";
import { connect } from "react-redux";
import CustomModal from "./Modal";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";

const headCellSx = {
  borderBottom: "1px solid #2a2a2a",
  color: "#777",
  fontSize: "12px",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  backgroundColor: "#111",
  py: 1.5,
};

const rowSx = {
  cursor: "pointer",
  transition: "0.2s",
  "& td": { borderBottom: "1px solid #1e1e1e", color: "#ccc" },
  "&:hover": { backgroundColor: "#1f1f1f", "& td": { color: "#FFC001" } },
};

const featuredRowSx = {
  ...rowSx,
  "& td": { borderBottom: "1px solid #2a2a2a", color: "#ccc" },
  backgroundColor: "rgba(255,192,1,0.04)",
};

const ListingTableHeadings = [
  "",
  "Name",
  "Category",
  "Last Updated",
  "Price",
  "Status",
  "Actions",
];

const ListingsList = ({
  handleOpenRemoveNFSModal,
  handleOpenDeleteModal,
  handleOpenAddToNFSModal,
  handleOpenAddToSoldModal,
  handleRemoveSoldModal,
  setOnHoldModalText,
  setOnHoldDialogText,
  data,
  classes,
  jwtToken,
  setListings,
  user,
  loadListings,
  handleOpenFeaturedModal,
  handleOpenMarkAsActiveModal,
  handleOpenHoldModal,
}) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuData, setMenuData] = useState(null);
  const [snackbarStates, setSnackbarStates] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [confirmProp, setConfirmProp] = useState(false);

  const handleCloseDeleteModal = () => setOpenDeleteModal(false);

  useEffect(() => {
    if (confirmProp) {
      window.location.href = user.billingPortalUrl;
    }
  }, [confirmProp]);

  const [processing, setProcessing] = useState(false);

  const findCategoryName = (id) => {
    const category = classes.filter((cat) => cat.id === parseInt(id))[0];
    if (category) {
      return category.name;
    } else {
      return "N/A";
    }
  };

  const getTimeElapsed = (featuredAt) => {
    const currentTime = new Date();
    const createdTime = new Date(featuredAt);
    const timeDifference = currentTime - createdTime;
    const hoursElapsed = Math.floor(timeDifference / (1000 * 60 * 60));
    return hoursElapsed;
  };

  const getIconColor = (data) => {
    const hoursElapsed = getTimeElapsed(data.featured_at);
    if (hoursElapsed > 18 && hoursElapsed < 24) {
      return "#FFC001";
    } else if (hoursElapsed >= 24) {
      return "red";
    }
    return "green";
  };

  const handleMarkAsActive = async (data) => {
    handleMenuClose();
    handleOpenMarkAsActiveModal(data);
  };

  const handleFeaturedListing = async (data) => {
    handleMenuClose();
    handleOpenFeaturedModal(data);
  };

  const handleMarkAsSold = async (data) => {
    setProcessing(true);
    let registerRequest;
    try {
      registerRequest = await axios.patch(
        `${config.SERVER_URL}/api/v1/animals/${data.id}`,
        {
          animal: {
            is_sold: !data.is_sold,
          },
          seller_id: data.seller_id,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data; ",
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
    } catch ({ response }) {
      registerRequest = response;

      if (registerRequest.status === 422) {
      }
      setProcessing(false);
    }

    const { data: registerRequestData } = registerRequest;
    if (registerRequest.status === 201 || registerRequest.status === 200) {
      loadListings();

      setSnackbarStates({
        open: true,
        message: registerRequestData.message,
        severity: "success",
      });
      setProcessing(false);
      handleMenuClose();
    }
  };

  const handleOpenSoldModal = async (data) => {
    handleOpenAddToSoldModal(data);
    handleMenuClose();
  };
  const handleCloseSoldModal = async (data) => {
    handleRemoveSoldModal(data);
    handleMenuClose();
  };

  const handleMarkAsNotForSale = async (data) => {
    handleOpenAddToNFSModal(data);
    handleMenuClose();
  };

  const handleNFS = (data) => {
    if (data.status === "nfs") {
      handleMenuClose();
      handleOpenRemoveNFSModal(data);
    } else {
      handleMarkAsNotForSale(data);
    }
  };
  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarStates({ ...snackbarStates, open: false });
  };

  const handleMenuClick = (event, data) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuOpen(true);
    setMenuData(data);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setMenuOpen(false);
    setMenuData(null);
  };

  const handleMarkAsHold = async (data) => {
    handleMenuClose();
    handleOpenHoldModal(data);
  };

  const handleMarkListingAsHold = (data) => {
    handleMarkAsHold(data);
    setOnHoldModalText("Remove from hold");
    setOnHoldDialogText(
      "Are you sure you want to remove from on-Hold? You can either Mark as Sold for this listing or set it to Active Listing."
    );
  };

  const handleRemoveListingAsHold = (data) => {
    handleMarkAsHold(data);
    setOnHoldModalText("Add to hold");
    setOnHoldDialogText(
      "Are you sure you want to put this listing on hold. This listing will still be visible to buyers indicating the deal is already in progress."
    );
  };

  return (
    <>
      <Snackbar
        transitionDuration={{ enter: 1000, exit: 2000 }}
        TransitionComponent={Slide}
        TransitionProps={{ enter: true, exit: false }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackbarStates.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          variant="filled"
          sx={{ width: "100%" }}
          severity={snackbarStates.severity}
        >
          {snackbarStates.message}
        </Alert>
      </Snackbar>
      <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "16px", overflow: "hidden" }}>
        {data && data.length > 0 ? (
          <Box sx={{ overflowX: "auto" }}>
            <Table sx={{ borderCollapse: "collapse" }}>
              <TableHead>
                <TableRow>
                  {ListingTableHeadings.map((item) => (
                    <TableCell key={item} align="center" sx={headCellSx}>
                      {item}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((item) => (
                  <TableRow
                    key={item.name}
                    sx={item.is_featured ? featuredRowSx : rowSx}
                  >
                    {item.media && item.media[0]?.url && (
                      <TableCell align="left" sx={{ width: 0, p: "8px 12px" }}>
                        <Avatar
                          width={40}
                          height={40}
                          alt={item.name}
                          src={item.media[0]?.url}
                          sx={{ width: 40, height: 40, borderRadius: "8px" }}
                        />
                      </TableCell>
                    )}
                    <TableCell sx={{ width: "8%" }}>
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
                        <Typography
                          component={Link}
                          to={`/listing/${item.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{
                            fontSize: "13px",
                            color: "#ccc",
                            textDecoration: "none",
                            "&:hover": { color: "#FFC001", textDecoration: "underline" },
                          }}
                        >
                          {item.name}
                        </Typography>
                        {item.is_featured === true && (
                          <WorkspacePremiumIcon
                            size="small"
                            sx={{ ml: 0.5, fontSize: 16, color: getIconColor(item) }}
                          />
                        )}
                        {item.on_hold === true && (
                          <PauseCircleOutlineIcon size="small" sx={{ ml: 0.5, fontSize: 16, color: "#FFC001" }} />
                        )}
                      </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ fontSize: "13px" }}>
                      {findCategoryName(item.category_id)}
                    </TableCell>
                    <TableCell align="center" sx={{ fontSize: "13px" }}>
                      {moment(item.last_updated).fromNow()}
                    </TableCell>
                    <TableCell align="center" sx={{ fontSize: "13px", color: "#FFC001 !important", fontWeight: 700 }}>
                      {"$" + item.price}
                    </TableCell>
                    <TableCell align="center" sx={{ fontSize: "13px" }}>
                      {item.status.split("_")[0] === "nfs"
                        ? "NFS"
                        : capitalizeFirstLetter(item.status.split("_")[0])}
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        component={Link}
                        to={`/seller/listing/edit/${item.id}`}
                        sx={{ color: "#666", "&:hover": { color: "#FFC001", backgroundColor: "rgba(255,192,1,0.08)" } }}
                        size="small"
                      >
                        <BorderColorIcon sx={{ fontSize: 16 }} />
                      </IconButton>

                      <IconButton
                        onClick={() => handleOpenDeleteModal(item.id)}
                        sx={{ color: "#666", "&:hover": { color: "#ff4444", backgroundColor: "rgba(255,68,68,0.08)" } }}
                        size="small"
                      >
                        <DeleteIcon sx={{ fontSize: 16 }} />
                      </IconButton>

                      <IconButton
                        aria-controls={`menu-${item.id}`}
                        aria-haspopup="true"
                        onClick={(event) => handleMenuClick(event, item)}
                        sx={{ color: "#666", "&:hover": { color: "#FFC001", backgroundColor: "rgba(255,192,1,0.08)" } }}
                        size="small"
                      >
                        <MoreVertIcon sx={{ fontSize: 16 }} />
                      </IconButton>
                      <Menu
                        id={`menu-${item.id}`}
                        anchorEl={menuAnchorEl}
                        open={menuOpen && menuData?.id === item.id}
                        onClose={handleMenuClose}
                        PaperProps={{ sx: { backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "10px" } }}
                      >
                        {!processing &&
                          !item.is_featured &&
                          item.status === "active_listing" &&
                          !item.on_hold && (
                            <MenuItem onClick={() => handleFeaturedListing(item)} sx={{ fontSize: "13px", color: "#ccc", "&:hover": { color: "#FFC001" } }}>
                              Add as Featured
                            </MenuItem>
                          )}
                        {!processing && item.status === "unavailable" && (
                          <MenuItem onClick={() => handleMarkAsActive(item)} sx={{ fontSize: "13px", color: "#ccc", "&:hover": { color: "#FFC001" } }}>
                            Mark as active
                          </MenuItem>
                        )}
                        {processing ? (
                          <MenuItem sx={{ display: "flex", justifyContent: "center" }}>
                            <CircularProgress size="24px" sx={{ color: "#FFC001" }} />
                          </MenuItem>
                        ) : (
                          item.status === "active_listing" && (
                            <>
                              <MenuItem onClick={() => handleOpenSoldModal(item)} sx={{ fontSize: "13px", color: "#ccc", "&:hover": { color: "#FFC001" } }}>
                                Mark as Sold
                              </MenuItem>
                              {item.is_featured !== true && (
                                <MenuItem onClick={() => handleMarkAsNotForSale(item)} sx={{ fontSize: "13px", color: "#ccc", "&:hover": { color: "#FFC001" } }}>
                                  Mark as NFS
                                </MenuItem>
                              )}
                              {item.on_hold ? (
                                <MenuItem onClick={() => handleMarkListingAsHold(item)} sx={{ fontSize: "13px", color: "#ccc", "&:hover": { color: "#FFC001" } }}>
                                  Remove from hold
                                </MenuItem>
                              ) : (
                                <MenuItem onClick={() => handleRemoveListingAsHold(item)} sx={{ fontSize: "13px", color: "#ccc", "&:hover": { color: "#FFC001" } }}>
                                  Mark on Hold
                                </MenuItem>
                              )}
                            </>
                          )
                        )}

                        {item.status === "nfs" && (
                          <MenuItem onClick={() => handleNFS(item)} sx={{ fontSize: "13px", color: "#ccc", "&:hover": { color: "#FFC001" } }}>
                            Remove from NFS
                          </MenuItem>
                        )}

                        {item.status === "sold" && (
                          <MenuItem onClick={() => handleCloseSoldModal(item)} sx={{ fontSize: "13px", color: "#ccc", "&:hover": { color: "#FFC001" } }}>
                            Remove from sold
                          </MenuItem>
                        )}

                        {item.status === "pending" && (
                          <MenuItem disabled sx={{ fontSize: "13px" }}>Pending Listing</MenuItem>
                        )}
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        ) : (
          <Box
            display="flex"
            alignItems="center"
            sx={{ py: 8 }}
            justifyContent="center"
            flexDirection="column"
            gap={2}
          >
            <Typography sx={{ fontSize: "14px", color: "#555" }}>
              You don't have any listings yet.
            </Typography>
            <Button
              component={Link}
              to={"/seller/listing/create"}
              sx={{ px: 3, py: 1, borderRadius: "10px", backgroundColor: "#FFC001", color: "#000", fontWeight: 800, fontSize: "13px", textTransform: "none", "&:hover": { backgroundColor: "#e6ac00" } }}
            >
              + Add Listing
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
};

const mapStateToProps = ({ Auth }) => ({
  jwtToken: Auth.jwtToken,
  user: Auth.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ListingsList);
